module.exports = __webpack_public_path__ + "static/media/hat.d4cc28f3.wav";